import { ISDSIcon } from "@sznds/icons";
import { ISDSIconMulti, TActivityType } from "~/interfaces";
import { ACTIVITY, ACTIVITY_ALPINE_TOURING, ACTIVITY_ALPINIST, ACTIVITY_CANOE, ACTIVITY_CAR, ACTIVITY_CARAVAN, ACTIVITY_CROSS_COUNTRY_SKIS, ACTIVITY_CYCLOTURIST, ACTIVITY_DOWNHILL_SKIS, ACTIVITY_GRAVEL_BIKE, ACTIVITY_HORSE_RIDING, ACTIVITY_INLINE_SKATES, ACTIVITY_KICK_SCOOTER, ACTIVITY_MOTORCYCLE, ACTIVITY_MOUNTAIN_BIKE, ACTIVITY_PADDLEBOARD, ACTIVITY_PARAGLIDE, ACTIVITY_PLANE, ACTIVITY_ROAD_BIKE, ACTIVITY_RUN, ACTIVITY_SNOWSHOES, ACTIVITY_STROLLER, ACTIVITY_TURIST, ACTIVITY_ICE_SKATES, PATH, PATH_ALPINE_TOURING, PATH_ALPINIST, PATH_CANOE, PATH_CAR, PATH_CARAVAN, PATH_CROSS_COUNTRY_SKIS, PATH_CYCLOTURIST, PATH_DOWNHILL_SKIS, PATH_GRAVEL_BIKE, PATH_HORSE_RIDING, PATH_INLINE_SKATES, PATH_KICK_SCOOTER, PATH_MOTORCYCLE, PATH_MOUNTAIN_BIKE, PATH_PADDLEBOARD, PATH_PARAGLIDE, PATH_PLANE, PATH_ROAD_BIKE, PATH_RUN, PATH_SNOWSHOES, PATH_STROLLER, PATH_TURIST, ROUTE, ROUTE_CANOE, ROUTE_CAR, ROUTE_CROSS_COUNTRY_SKIS, ROUTE_CYCLOTURIST, ROUTE_MHD, ROUTE_TURIST, PATH_EBIKE, PATH_FERRATA, PATH_ICE_SKATES, ACTIVITY_EBIKE, ACTIVITY_FERRATA } from "~/ui/sds-compatible-icons";
import { IRouteConst } from "~/route/const";

/* eslint-disable quote-props */
export const ACTIVITY_TYPE_TO_ICON: {
	[K in TActivityType]: ISDSIconMulti;
} = {
	"auto_moto": ACTIVITY_CAR,
	"beh": ACTIVITY_RUN,
	"bezky": ACTIVITY_CROSS_COUNTRY_SKIS,
	"gravel": ACTIVITY_GRAVEL_BIKE,
	"horolezectvi": ACTIVITY_ALPINIST,
	"horske_kolo": ACTIVITY_MOUNTAIN_BIKE,
	"inline": ACTIVITY_INLINE_SKATES,
	"jezdectvi": ACTIVITY_HORSE_RIDING,
	"karavan": ACTIVITY_CARAVAN,
	"kocarek": ACTIVITY_STROLLER,
	"kolobezka": ACTIVITY_KICK_SCOOTER,
	"letadlo": ACTIVITY_PLANE,
	"motorka": ACTIVITY_MOTORCYCLE,
	"nakole": ACTIVITY_CYCLOTURIST,
	"paddleboard": ACTIVITY_PADDLEBOARD,
	"paraglide": ACTIVITY_PARAGLIDE,
	"pesky": ACTIVITY_TURIST,
	"silnicni_kolo": ACTIVITY_ROAD_BIKE,
	"sjezd": ACTIVITY_DOWNHILL_SKIS,
	"skialpy": ACTIVITY_ALPINE_TOURING,
	"sneznice": ACTIVITY_SNOWSHOES,
	"vodactvi": ACTIVITY_CANOE,
	"ekolo": ACTIVITY_EBIKE,
	"ferrata": ACTIVITY_FERRATA,
	"brusle": ACTIVITY_ICE_SKATES,
};
/* eslint-enable quote-props */

/* eslint-disable quote-props */
export const PATH_TYPE_TO_ICON: {
	[K in TActivityType]: ISDSIconMulti;
} = {
	"auto_moto": PATH_CAR,
	"beh": PATH_RUN,
	"bezky": PATH_CROSS_COUNTRY_SKIS,
	"gravel": PATH_GRAVEL_BIKE,
	"horolezectvi": PATH_ALPINIST,
	"horske_kolo": PATH_MOUNTAIN_BIKE,
	"inline": PATH_INLINE_SKATES,
	"jezdectvi": PATH_HORSE_RIDING,
	"karavan": PATH_CARAVAN,
	"kocarek": PATH_STROLLER,
	"kolobezka": PATH_KICK_SCOOTER,
	"letadlo": PATH_PLANE,
	"motorka": PATH_MOTORCYCLE,
	"nakole": PATH_CYCLOTURIST,
	"paddleboard": PATH_PADDLEBOARD,
	"paraglide": PATH_PARAGLIDE,
	"pesky": PATH_TURIST,
	"silnicni_kolo": PATH_ROAD_BIKE,
	"sjezd": PATH_DOWNHILL_SKIS,
	"skialpy": PATH_ALPINE_TOURING,
	"sneznice": PATH_SNOWSHOES,
	"vodactvi": PATH_CANOE,
	"ekolo": PATH_EBIKE,
	"ferrata": PATH_FERRATA,
	"brusle": PATH_ICE_SKATES,
};
/* eslint-enable quote-props */

/* eslint-disable quote-props */
export const ROUTE_TYPE_TO_ICON: {
	[K in keyof IRouteConst["types"]]: ISDSIconMulti;
} = {
	"car": ROUTE_CAR,
	"ski": ROUTE_CROSS_COUNTRY_SKIS,
	"bike": ROUTE_CYCLOTURIST,
	"pubt": ROUTE_MHD,
	"water": ROUTE_CANOE,
	"trial": ROUTE_TURIST,
};
/* eslint-enable quote-props */

export function activityTypeToMapIcon(type: TActivityType): ISDSIconMulti | ISDSIcon {
	if (type in ACTIVITY_TYPE_TO_ICON) {
		return ACTIVITY_TYPE_TO_ICON[type];
	}

	return ACTIVITY;
}

export function pathTypeToMapIcon(type: TActivityType): ISDSIconMulti | ISDSIcon {
	if (type in PATH_TYPE_TO_ICON) {
		return PATH_TYPE_TO_ICON[type];
	}

	return PATH;
}

export function routeTypeToMapIcon(type: keyof IRouteConst["types"]): ISDSIconMulti | ISDSIcon {
	if (type in ROUTE_TYPE_TO_ICON) {
		return ROUTE_TYPE_TO_ICON[type];
	}

	return ROUTE;
}
